import { Component, HostListener, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ConfirmationDialogData } from './confirmation-dialog-data';
import { FormBuilder, FormGroup } from '@angular/forms';
// import { MatDialogContent } from '@angular/material/dialog';

@Component({
  selector: 'pgh-confirmation-dialog',
  templateUrl: './confirmation-dialog.component.html',
  styleUrls: ['./confirmation-dialog.component.scss']
})

export class ConfirmationDialogComponent implements OnInit {
  public confirmPhoneNumber: string;
  public form: FormGroup;

  public constructor(
    @Inject(MAT_DIALOG_DATA) public data: ConfirmationDialogData,
    fb: FormBuilder
  ) {
    this.form = fb.group({
      phoneNumber: ['']
    })
  }

  public get isPhoneNumberMatching(): boolean {
      return this.data.phoneNumber.replace(/[^0-9]/g, "").substring(6) === this.form.get('phoneNumber').value;
  }

  public get hasError(): boolean {
    if (!this.isPhoneNumberMatching && this.form.get('phoneNumber').value.length == 4) {
      return true;
    }
    return false;
  }

  public ngOnInit(): void {
  }

}
